export type VideoService = 'YouTube' | 'Vimeo' | 'Loom';

interface ServicePattern {
    service: VideoService;
    patterns: RegExp[];
}

const SERVICE_PATTERNS: ServicePattern[] = [
    {
        service: 'YouTube',
        patterns: [
            // Standard YouTube watch page URLs (from YouTube website)
            /youtube\.com\/watch\?v=([\w-]+)/,
            // YouTube shortened URLs (from Share button)
            /youtu\.be\/([\w-]+)/,
            // YouTube embed URLs (from Embed button)
            /youtube\.com\/embed\/([\w-]+)/
        ]
    },
    {
        service: 'Vimeo',
        patterns: [
            // Standard Vimeo page URLs (from Vimeo website)
            /vimeo\.com\/(\d+)/,
            // Vimeo player URLs (from Share > Embed button)
            /player\.vimeo\.com\/video\/(\d+)/
        ]
    },
    {
        service: 'Loom',
        patterns: [
            // Loom share URLs
            /loom\.com\/share\/([\dA-Za-z]+)/,
            // Loom embed URLs
            /loom\.com\/embed\/([\dA-Za-z]+)/
        ]
    }
];

/** Extracts video ID and service from a URL */
export const getVideoInfo = (
    url: string
): { service: VideoService; videoId: string } | null => {
    for (const { service, patterns } of SERVICE_PATTERNS) {
        for (const pattern of patterns) {
            const match = url.match(pattern);
            if (match && match[1]) {
                return { service, videoId: match[1] };
            }
        }
    }
    return null;
};
